const DEFAULT_TIMEOUT_MS = 15000;

export const fetchWithTimeout = async (url, options = {}) => {
  const { timeoutMs = DEFAULT_TIMEOUT_MS, signal, ...rest } = options;

  const controller = new AbortController();
  const signalTargets = [controller.signal];
  if (signal) {
    signalTargets.push(signal);
  }

  const timeoutId = setTimeout(() => {
    controller.abort(new DOMException(`Request timeout after ${timeoutMs}ms`, 'TimeoutError'));
  }, timeoutMs);

  const onAbort = () => controller.abort(signal?.reason);
  signal?.addEventListener('abort', onAbort, { once: true });

  try {
    const response = await fetch(url, {
      ...rest,
      signal: signalTargets[0],
    });

    return response;
  } finally {
    clearTimeout(timeoutId);
    signal?.removeEventListener('abort', onAbort);
  }
};

export const isTimeoutError = (error) => error?.name === 'TimeoutError' || error?.name === 'AbortError';
